document.addEventListener('DOMContentLoaded', () => {
  // Pré-carrega os dados de quick add assim que aparecem na tela em mobile
  const quickAddElements = document.querySelectorAll('.resource-list__carousel quick-add-component');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const quickAdd = entry.target;
          const productPageUrl = quickAdd.productPageUrl;
          if (productPageUrl && !quickAdd.cachedProductHtml) {
            quickAdd.fetchProductPage(productPageUrl);
          }
          observer.unobserve(quickAdd);
        }
      });
    }, { rootMargin: '200px' });

    quickAddElements.forEach((el) => observer.observe(el));
  }

  // Resto do código do carrossel (navegação por toque)
  document.querySelectorAll('.resource-list__carousel').forEach(carousel => {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTime = 0;

    carousel.addEventListener('touchstart', (e) => {
      if (e.target.closest('quick-add-component')) return;
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      touchStartTime = Date.now();
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      if (e.target.closest('quick-add-component')) return;
      if (carousel.querySelector('slideshow-component[dragging]')) return;

      const touch = e.changedTouches[0];
      const deltaX = Math.abs(touch.clientX - touchStartX);
      const deltaY = Math.abs(touch.clientY - touchStartY);
      const deltaTime = Date.now() - touchStartTime;

      if (deltaX > 10 || deltaY > 10 || deltaTime > 500) return;

      const interactive = e.target.closest('button, input, label, select');
      if (interactive) return;

      const card = e.target.closest('product-card');
      if (!card) return;

      const link = card.querySelector('a.product-card__link');
      if (!link?.href) return;

      e.preventDefault();
      window.location.href = link.href;
    }, { passive: false });
  });
});